import React, { Component } from 'react';
import * as $ from 'jquery';
import BalanceDialog from './BalanceDialog.js';
import CompanyProfile from './CompanyProfile.js';
import UserProfile from './UserProfile.js';
import axios from 'axios';
import moment from 'moment-timezone';
import { MENU } from '../Sidebar.js';
import { translate } from 'react-i18next';
import PassportContainer from './PassportContainer.js';
import PasswordChange from './PasswordChange';
import FacturasContainer from './FacturasContainer.js';
import { ESTADO_CIVIL, GENERO, HIJOS, FOOD, EMERGENCY_CONTACT } from './passportOptions.js';

export const GENDER = {
  MALE: 1,
  FEMALE: 2
};

let cancelToken;
let state;
let tokenSession;

class ProfileContainer extends Component {

  constructor(props) {
    super(props);
    if (tokenSession !== props.getTokenSession()) {
      state = this.getInitState();
    }
    this.state = state;
  }

  componentWillMount() {
    cancelToken = axios.CancelToken.source();
  }

  componentDidMount() {
    this.reload();
  }

  componentWillUnmount() {
    state = this.state;
    cancelToken.cancel('Component will unmount.');
    tokenSession = this.props.getTokenSession();
  }

  companyPicture = (params) => {
    this.props.post(
      "/companyPicture",
      params,
      this.reload,
      (error) => this.props.handleErrorResponse(error),
      cancelToken
    );
  }

  didGetBusiness = (response) => {
    this.setState({ business: response });
  }

  didChangePasswordUser = (response) => {
    alert('La contraseña se actualizo')
    window.location.reload()
  }

  didGetProfile = (response) => {
    let interests = "";
    response.interests.map((interest) => interests += interest.name + " ");

    this.props.setUser(Object.assign(
      {},
      this.props.user,
      { lastname: response.lastname },
      { name: response.name },
      { picture: response.picture }
    ));

    this.setState({
      user: Object.assign({},
        response,
        { birthdate: moment(response.birthdate, 'YYYY-MM-DD').format('MM/DD/YYYY') },
        { interests: interests }
      )
    });
  }

  didGetPassport = (response) => {
    if (response.code === 9998 && response.msg !== "NO_ACCESS") {
      let passport = this.addOptionsToPassportFields(response.passport);
      this.setState({ passport: passport });
    } else if (response.code === 6666 && response.msg === "NO_ACCESS") {
      this.setState({ hasPassportAccess: false });
    } else {
      this.props.handleErrorResponse(null);
    }
  }

  addOptionsToPassportFields(passport) {
    var options = passport.filter(f => f.type === 'options' || f.type === 'radio');

    //agregar las opciones a los objetos:
    var hijos = options.find(f => f.id === 'hijos');
    hijos.options_available = HIJOS;

    var genero = options.find(f => f.id === 'genero');
    genero.options_available = GENERO;

    var civil = options.find(f => f.id === 'estado_civil');
    civil.options_available = ESTADO_CIVIL;

    var food = options.find(f => f.id === 'food');
    food.options_available = FOOD;

    var emergency_c = options.find(f => f.id === 'emergency_relation');
    emergency_c.options_available = EMERGENCY_CONTACT;

    //sustituir los objetos modificados en el passaport original
    var foundIndex = passport.findIndex(x => x.id === hijos.id);
    passport[foundIndex] = hijos;
    foundIndex = passport.findIndex(x => x.id === genero.id);
    passport[foundIndex] = genero;
    foundIndex = passport.findIndex(x => x.id === civil.id);
    passport[foundIndex] = civil;
    foundIndex = passport.findIndex(x => x.id === food.id);
    passport[foundIndex] = food;
    foundIndex = passport.findIndex(x => x.id === emergency_c.id);
    passport[foundIndex] = emergency_c;

    return passport;
  }

  editProfile = (params) => {
    this.props.post(
      "/editProfile",
      params,
      this.reload,
      (error) => this.props.handleErrorResponse(error),
      cancelToken
    );
  }

  getBusiness = (params) => {
    this.props.post(
      "/getBusiness",
      params,
      (response) => this.didGetBusiness(response),
      (error) => this.props.handleErrorResponse(error),
      cancelToken
    );
  }

  getChangePassword = (params) => {
    this.props.post(
      "/changePasswordUser",
      params,
      (response) => this.didChangePasswordUser(response),
      (error) => this.props.handleErrorResponse(error),
      cancelToken
    );
  }

  getInitState = () => {
    return {
      isPassworChange: false,
      business: [],
      password: "",
      passwordConfirm: "",
      user: null,
      passport: null,
      hasPassportAccess: true
    };
  }

  getProfile = (params) => {
    this.props.post(
      "/getProfile",
      params,
      (response) => this.didGetProfile(response),
      (error) => this.props.handleErrorResponse(error),
      cancelToken
    );
  }

  getPassport = (params) => {
    this.props.post(
      "/getPassport",
      params,
      (response) => this.didGetPassport(response),
      (error) => this.props.handleErrorResponse(error),
      cancelToken
    );
  }

  handleAssistantProcedure = (event) => {
    this.setState({
      user: Object.assign({},
        this.state.user,
        { assistant_procedure: event.target.value }
      )
    });
  }

  handlePasswordChange = (event) => {
    this.setState({ password: event.target.value })
  }

  handlePasswordConfirm = (event) => {
    this.setState({ passwordConfirm: event.target.value })
  }

  handlePasswordSubmit = (event) => {

    event.preventDefault();
    const { t } = this.props;

    if (this.state.password !== this.state.passwordConfirm) {
      alert(t('guest.password.error_password'));
      return;
    }

    const uppercaseRegExp   = /(?=.*?[A-Z])/;
    const lowercaseRegExp   = /(?=.*?[a-z])/;
    const digitsRegExp      = /(?=.*?[0-9])/;
    const specialCharRegExp = /(?=.*?[#?!@$%^&*-])/;
    const minLengthRegExp   = /.{8,}/;

    const passwordLength = this.state.password.length;
    const uppercasePassword = uppercaseRegExp.test(this.state.password);
    const lowercasePassword = lowercaseRegExp.test(this.state.password);
    const digitsPassword = digitsRegExp.test(this.state.password);
    const specialCharPassword = specialCharRegExp.test(this.state.password);
    const minLengthPassword = minLengthRegExp.test(this.state.password);

    if (passwordLength === 0) {
      alert("La contraseña está vacía");
      return;
    } else if (!uppercasePassword) {
      alert("La contraseña debe tenerl al menos una mayúsculas");
      return;
    } else if (!lowercasePassword) {
      alert("La contraseña debe tenerl al menos una minúsculas");
      return;
    } else if (!digitsPassword) {
      alert("La contraseña debe tenerl al menos un numero ");
      return;
    } else if (!specialCharPassword) {
      alert("La contraseña debe tenerl al menos un caracter especial");
      return;
    } else if (!minLengthPassword) {
      alert("La contraseña debe tenerl al menos 8 un caracteres");
      return;
    }  
    this.getChangePassword({
      token_id: this.props.getTokenId(),
      token_session: this.props.getTokenSession(),
      password: this.state.password,
    });
  }

  handleAssistantReply = (event) => {
    this.setState({
      user: Object.assign({},
        this.state.user,
        { assistant_reply: event.target.value }
      )
    });
  }

  handleBirthdateChange = (birthdate) => {
    this.setState({
      user: Object.assign({},
        this.state.user,
        { birthdate: birthdate }
      )
    });
  }

  handleBusinessChange = (event) => {
    this.setState({
      user: Object.assign({},
        this.state.user,
        { business_id: event.target.value }
      )
    });
  }

  handleCancelClick = () => {
    this.reload();
  }

  handleCompanyChange = (event) => {
    this.setState({
      user: Object.assign({},
        this.state.user,
        { company: event.target.value }
      )
    });
  }

  handleCompanyPicture = (event) => {
    const params = new FormData();
    params.append("picture", event.target.files[0]);
    params.append("token_id", this.props.getTokenId());
    params.append("token_session", this.props.getTokenSession());
    this.companyPicture(params);
  }

  handleContactEmail = (event) => {
    this.setState({
      user: Object.assign({},
        this.state.user,
        { contact_email: event.target.value }
      )
    });
  }

  handleDescriptionChange = (event) => {
    this.setState({
      user: Object.assign({},
        this.state.user,
        { description: event.target.value }
      )
    });
  }

  handleDiscountChange = (event) => {
    this.setState({
      user: Object.assign({},
        this.state.user,
        { discount: event.target.value }
      )
    });
  }

  handleGenderChange = (event) => {
    this.setState({
      user: Object.assign({},
        this.state.user,
        { gender: event.target.value }
      )
    });
  }

  handleInterestsChange = (event) => {
    this.setState({
      user: Object.assign({},
        this.state.user,
        { interests: event.target.value }
      )
    });
  }

  handleLastnameChange = (event) => {
    this.setState({
      user: Object.assign({},
        this.state.user,
        { lastname: event.target.value }
      )
    });
  }

  handleNameChange = (event) => {
    this.setState({
      user: Object.assign({},
        this.state.user,
        { name: event.target.value }
      )
    });
  }

  handlePhoneChange = (event) => {
    this.setState({
      user: Object.assign({},
        this.state.user,
        { phone: event.target.value }
      )
    });
  }

  handlePositionChange = (event) => {
    this.setState({
      user: Object.assign({},
        this.state.user,
        { position: event.target.value }
      )
    });
  }

  handleProfileLinkedinChange = (event) => {
    this.setState({
      user: Object.assign({},
        this.state.user,
        { perfilLinkedin: event.target.value }
      )
    });
  }

  handleProfileInstagramChange = (event) => {
    this.setState({
      user: Object.assign({},
        this.state.user,
        { perfil_Instragram: event.target.value }
      )
    });
  }

  handleProfileFacebookChange = (event) => {
    this.setState({
      user: Object.assign({},
        this.state.user,
        { perfil_facebook: event.target.value }
      )
    });
  }

  handleProfilePublicChange = (event) => {
    this.setState({
      user: Object.assign({},
        this.state.user,
        { perfil_publico: event.target.value }
      )
    });
  }

  handleProfilePicture = (event) => {
    const params = new FormData();
    params.append("picture", event.target.files[0]);
    params.append("token_id", this.props.getTokenId());
    params.append("token_session", this.props.getTokenSession());
    this.profilePicture(params);
  }

  handleProfileSubmit = (event) => {
    event.preventDefault();
    this.editProfile(Object.assign({},
      this.state.user,
      { birthdate: moment(this.state.user.birthdate, 'MM/DD/YYYY').format('YYYY-MM-DD') },
      { interests: this.state.user.interests.trim().replace(/ /g, ",") },
      { token_id: this.props.getTokenId() },
      { token_session: this.props.getTokenSession() }
    ));
  }

  handlePassportSubmit = (event) => {
    event.preventDefault();
    this.props.post("/editPassport", Object.assign({},
      this.state.passport,
      { token_id: this.props.getTokenId() },
      { token_session: this.props.getTokenSession() },
      { phone: this.state.user.phone },
      { birthdate: this.state.user.birthdate },
      { gender: this.state.user.gender },
      { email: this.state.user.email }
    ), this.reload, (error) => this.props.handleErrorResponse(error), cancelToken);
  }

  handlePasswordClick = (event) => {
    $('#btnPassworChange').click();
  }

  handleWebsiteChange = (event) => {
    this.setState({
      user: Object.assign({},
        this.state.user,
        { website: event.target.value }
      )
    });
  }

  profilePicture = (params) => {
    this.props.post(
      "/profilePicture",
      params,
      this.reload,
      (error) => this.props.handleErrorResponse(error),
      cancelToken
    );
  }

  showBalance = () => {
    $('#btnBalance').click();
  }

  handlePasswordClick = () => {
    $('#btnPassworChange').click();
  }

  reload = () => {
    this.getProfile({
      token_id: this.props.getTokenId(),
      token_session: this.props.getTokenSession()
    });

    this.getBusiness({
      token_id: this.props.getTokenId(),
      token_session: this.props.getTokenSession()
    });

    this.getPassport({
      token_id: this.props.getTokenId(),
      token_session: this.props.getTokenSession()
    });

  }

  renderBalanceDialog = () => {
    return (
      <BalanceDialog balance={this.state.user.balance} />
    );
  }

  renderCompanyFacturas = () => {
    return (
      <FacturasContainer
        getPermissionStatus={this.getPermissionStatus}
        getTokenId={this.props.getTokenId}
        getTokenSession={this.props.getTokenSession}
        handleErrorResponse={this.props.handleErrorResponse}
        post={this.props.post}
        setUser={this.props.setUser}
        user={this.props.user} />
    );
  }

  renderCompanyProfile = () => {
    return (
      <CompanyProfile
        business={this.state.business}
        handleAssistantProcedure={this.handleAssistantProcedure}
        handleAssistantReply={this.handleAssistantReply}
        handleBusinessChange={this.handleBusinessChange}
        handleCancelClick={this.handleCancelClick}
        handleCompanyChange={this.handleCompanyChange}
        handleCompanyPicture={this.handleCompanyPicture}
        handleDescriptionChange={this.handleDescriptionChange}
        handleDiscountChange={this.handleDiscountChange}
        handleProfileSubmit={this.handleProfileSubmit}
        handleWebsiteChange={this.handleWebsiteChange}
        user={this.state.user} />
    );
  }

  renderChangePasswor = () => {
    return (
      <PasswordChange
        user={this.state.user}
        password={this.state.password}
        passwordConfirm={this.state.passwordConfirm}
        handlePasswordChange={this.handlePasswordChange}
        handlePasswordConfirm={this.handlePasswordConfirm}
        handlePasswordSubmit={this.handlePasswordSubmit} />
    );
  }

  renderPassport = () => {
    return (
      <PassportContainer
        passport={this.state.passport}
        handleCancelClick={this.handleCancelClick}
        handlePassportSubmit={this.handlePassportSubmit} />
    );
  }

  renderUserProfile = () => {
    return (
      <UserProfile
        business={this.state.business}
        handleBirthdateChange={this.handleBirthdateChange}
        handleCancelClick={this.handleCancelClick}
        handleContactEmail={this.handleContactEmail}
        handleGenderChange={this.handleGenderChange}
        handleInterestsChange={this.handleInterestsChange}
        handleLastnameChange={this.handleLastnameChange}
        handleNameChange={this.handleNameChange}
        handlePhoneChange={this.handlePhoneChange}
        handlePositionChange={this.handlePositionChange}
        handleProfilePicture={this.handleProfilePicture}
        handleProfileSubmit={this.handleProfileSubmit}
        showBalance={this.showBalance}
        handleBusinessChange={this.handleBusinessChange}
        handleProfileLinkedinChange={this.handleProfileLinkedinChange}
        handleProfileInstagramChange={this.handleProfileInstagramChange}
        handleProfileFacebookChange={this.handleProfileFacebookChange}
        handleProfilePublicChange={this.handleProfilePublicChange}
        handleDescriptionChange={this.handleDescriptionChange}
        handlePasswordClick={this.handlePasswordClick}
        user={this.state.user} />
    );
  }

  render() {
    const { t } = this.props;
    const permissionStatus = this.props.getPermissionStatus(MENU.PROFILE);
    const user = this.state.user;
    const passport = this.state.passport;

    return (
      <div>
        <h2 className="page-header">{t('dashboard.profile.heading')}</h2>
        {permissionStatus && <div className="jumbotron alert-warning">{permissionStatus}</div>}
        <div className="panel with-nav-tabs panel-default panel-profile">
          <ul className="nav nav-tabs">
            <li className="active">
              <a href="#tab1default" data-toggle="tab">
                <div className="logo-movil">
                  <i className="fa fa-user" aria-hidden="true"></i>
                </div>
                <div className="text-desktop">
                  {"Información personal"}
                </div>
              </a>
            </li>
            <li>
              <a href="#tab2default" data-toggle="tab">
                <div className="logo-movil">
                  <i className="fa fa-fw fa-building" aria-hidden="true"></i>
                </div>
                <div className="text-desktop">
                  {"Información de la empresa"}
                </div>

              </a>
            </li>
            <li>
              <a href="#tab3default" data-toggle="tab">
                <div className="logo-movil">
                  <i className="fa fa-address-card-o" aria-hidden="true"></i>
                </div>
                <div className="text-desktop">
                  {"Pasaporte IOS"}
                </div>
              </a>
            </li>
            <li>
              <a href="#tab4default" data-toggle="tab">
                <div className="logo-movil">
                  <i className="fa fa-address-card-o" aria-hidden="true"></i>
                </div>
                <div className="text-desktop">
                  {"Datos de Factura"}
                </div>
              </a>
            </li>
          </ul>

          <div className="panel-body">
            <div className="tab-content">
              <div className="tab-pane fade in active" id="tab1default">
                <div>
                  {user && this.renderUserProfile()}
                  {user && user.balance && this.renderBalanceDialog()}
                  {user && this.renderChangePasswor()}
                </div>
              </div>
              <div className="tab-pane fade" id="tab2default">
                {user && this.state.business.length > 0 && this.renderCompanyProfile()}
              </div>
              <div className="tab-pane fade" id="tab3default">
                {passport && this.state.hasPassportAccess && this.renderPassport()
                  ? this.renderPassport()
                  : <h2 className="page-header">EXCLUSIVOS PARA SOCIOS</h2>
                }
              </div>
              <div className="tab-pane fade" id="tab4default">
                {this.renderCompanyFacturas()}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default translate('common')(ProfileContainer);



// WEBPACK FOOTER //
// ./src/dashboard/profile/ProfileContainer.js